<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">{{routeName}}</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/groups" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="createGroup">
                 <div class="row justify-content-md-center">
              <div class="col-12">
                <div class="row">
                  <div class="col-md-12">
                    <fg-input type="text"
                              v-model="group.groupTitle"
                              label="Group Title"
                              placeholder="Enter Title"
                              v-validate="rules.groupTitle"
                              data-vv-name="title"
                              cus-name="title"
                              :has-errors="errors"
                              :is-fields="fields">
                    </fg-input>
                  </div>
                  <div class="col-md-12">
                    <fg-input type="text"
                              v-model="group.groupDescription"
                              label="Group Description"
                              placeholder="Enter Description"
                              v-validate="rules.groupDescription"
                              data-vv-name="description"
                              cus-name="description"
                              :has-errors="errors"
                              :is-fields="fields">
                    </fg-input>
                  </div>
                  <div class="col-12" v-if="interests.length">
                    <label>Select Group Interests &nbsp;  <input type="checkbox" class="form-input" v-model="selectAllInterest"> Select All</label>
                    <multiselect v-if="interests"
                                 :disabled= "selectAllInterest"
                                 v-model="group.csvGroupInterestsId"
                                 placeholder="Select Interests"
                                 :multiple="true"
                                 :options="interests.map(type => type.interestId)"
                                 :custom-label="opt => interests.find(x => x.interestId == opt).interest"
                                  required>
                                >
                    </multiselect>
                  </div>
                    <div class="col-12" v-if="experts.length">
                      <label>Select Group Experts &nbsp;<input type="checkbox" class="form-input" v-model="selectAllExpert"> Select All
                      </label>
                      <multiselect
                        :disabled="selectAllExpert"
                        v-model="group.csvGroupExpertsId"
                        placeholder="Select Experts"
                        :multiple="true"
                        :options="experts.map(type => type.expertId)"
                        :custom-label="opt => experts.find(x => x.expertId == opt).name"
                        required>
                        >
                      </multiselect>
                  </div>
                  <div class="col-12" v-if="tendingPlaylists.length">
                    <label>Select Group Trending Playlists <input type="checkbox" class="form-input" v-model="selectAllPlaylists"> Select All </label>
                    <multiselect
                      :disabled="selectAllPlaylists"
                      v-model="group.csvGroupTrendPlaylistId"
                      placeholder="Select Trending Playlists"
                      :multiple="true"
                      :options="tendingPlaylists.map(type => type.playlistId)"
                      :custom-label="opt => tendingPlaylists.find(x => x.playlistId == opt).playlistTitle"
                      required>
                      >
                    </multiselect>
                  </div>
                  <div class="col-12" v-if="articles.length">
                    <label>Select Group Articles&nbsp;<input type="checkbox" class="form-input" v-model="selectAllArticle"> Select All</label>
                    <multiselect
                      :disabled="selectAllArticle"
                      v-model="group.csvGroupArticlesId"
                      placeholder="Select TONE Articles"
                      :multiple="true"
                      :options="articles.map(type => type.toneArticleId)"
                      :custom-label="opt => articles.find(x => x.toneArticleId == opt).articleHead"
                      required>
                      >
                    </multiselect>
                  </div>
                  <div class="col-12" v-if="tags.length">
                    <label>Select/Add Custom Tags</label>
                    <multiselect v-if="tags"
                                 v-model="selectedTags"
                                 tag-placeholder="Add this as new Tag"
                                 placeholder="Select or Add Tags"
                                 :multiple="true"
                                 label="tagKey"
                                 track-by="tagKey"
                                 :taggable="true"
                                 @tag="addTag"
                                 :options="tags"
                                 required>
                      >
                    </multiselect>
                  </div>
                  <div class="col-md-3" v-bind:style="{ color: group.headerColor}">
                    <fg-input type="text"
                              v-model="group.headerColor"
                              label="Header Color"
                              placeholder="Enter Color Code"
                             >
                    </fg-input>
                  </div>
                  <div class="col-md-3" v-bind:style="{ color: group.footerColor}">
                    <fg-input type="text"
                              v-model="group.footerColor"
                              label="Footer Color"
                              placeholder="Enter Color Code"
                    >
                    </fg-input>
                  </div>
                  <div class="col-md-3" v-bind:style="{ color: group.buttonColor}">
                    <fg-input type="text"
                              v-model="group.buttonColor"
                              label="Button Color"
                              placeholder="Enter Color Code"
                    >
                    </fg-input>
                  </div>
                  <div class="col-md-3" v-bind:style="{ color: group.headingColor}">
                    <fg-input type="text"
                              v-model="group.headingColor"
                              label="Heading Color"
                              placeholder="Enter Color Code"
                    >
                    </fg-input>
                  </div>

                  <div class="col-md-3" >
                    <fg-input type="number" min="15"
                              v-model="group.minVidReqdWork"
                              label="Min Limit for Work Menu"
                              placeholder="Enter Number"
                    >
                    </fg-input>
                  </div>
                  <div class="col-md-3" >
                    <fg-input type="number" min="15"
                              v-model="group.minVidReqdLife"
                              label="Min Limit for Life Menu"
                              placeholder="Enter Number"
                    >
                    </fg-input>
                  </div>
                  <div class="col-md-3" >
                    <fg-input type="number" min="15"
                              v-model="group.minVidReqdMindBody"
                              label="Min Limit for Mindbody Menu"
                              placeholder="Enter Number"
                    >
                    </fg-input>
                  </div>
                  <div class="col-md-3" >
                    <fg-input type="number" min="15"
                              v-model="group.minVidReqdMoney"
                              label="Min Limit for Money Menu"
                              placeholder="Enter Number"
                    >
                    </fg-input>
                  </div>
                  <div class="col-md-3" v-if="status.length">
                    <fg-select
                      v-model="group.active"
                      label="Active"
                      v-validate="rules.active"
                      data-vv-name="active"
                      cus-name="active"
                      :has-errors="errors"
                      :is-fields="fields"
                      :list="status"
                      selectedKey="id"
                    >
                    </fg-select>
                  </div>
                </div>
              </div>
              <div class="col-6 text-center">
                <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                  Create Group
                </button>
              </div>
            </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import moment from 'moment'
    export default {
        name: 'createGroup',
        data () {
        return {
           selectedTags: [],
            selectedCorpId: null,
            selectAllInterest: false,
            selectAllExpert: false,
            selectAllArticle: false,
            selectAllPlaylists: false,
            tags: [],
            type: '',
            corporations: [],
            corporationsList: [],
            packages: [],
            interests: [],
            experts: [],
            articles: [],
            tendingPlaylists: [],
            group: {
              groupTitle: '',
              groupDescription: '',
              csvGroupInterestsId: null,
              csvGroupExpertsId: null,
              csvGroupTrendPlaylistId: null,
              csvGroupArticlesId: null,
              csvGroupVideoTags: null,
              headerColor: '#f0617d',
              footerColor: '#f0617d',
              buttonColor: '#f0617d',
              headingColor: '#f0617d',
              active: 1,
              selectAllInterest: 0,
              selectAllExpert: 0,
              selectAllArticle: 0,
              selectAllTrendPlaylist: 0,
              minVidReqdWork: 15,
              minVidReqdLife: 15,
              minVidReqdMindBody: 15,
              minVidReqdMoney: 15
            },
          status: [{name:'Select Status'}, {id:1, name:'Active'}, {id:0, name:'Inactive'}],
            rules: {
              groupTitle : {required: true},
              groupDescription: {required: true}
            }
        }
    },
    methods: {
      addTag (newTag) {
        let self = this
        console.log('newTAg', newTag)
        let findTag = this.tags.filter (x => {
          return x.tagKey === newTag
        })
        console.log('found', findTag)
        if (!findTag || findTag.length === 0) {
        const tag = {
          videoTagId: 1,
          tagKey: newTag,
          videoTag: newTag,
          corporationId: 0,
          active: 1
        }
        console.log('new tag', tag)
        self.tags.push(tag)
        self.selectedTags.push(tag)
        // this.group.csvGroupVideoTags.push(tag)
          console.log('tagged', this.tags)
        }
      },
      customLabel (option) {
        return option.name.toString().toUpperCase()
      },
      fetchInterests () {
        this.$store.dispatch('FETCH_INTERESTS_GROUP')
          .then((res) => {
            this.interests = res;
            console.log("interests : ", this.interests);
          })
          .catch(err => {
            console.log("API error : ", err);
          }),
          (err) => {
            console.log("err : ", err);
          }
      },
      fetchTags () {
        this.$store.dispatch('FETCH_CUSTOM_TAGS')
          .then((res) => {
            this.tags = res;
            console.log("tags : ", this.tags);
          })
          .catch(err => {
            console.log("API error : ", err);
          }),
          (err) => {
            console.log("err : ", err);
          }
      },
      fetchExperts () {
        this.$store.dispatch('FETCH_EXPERTS_GROUP')
          .then((res) => {
            this.experts = res;
            console.log("experts: ", this.experts);
          })
          .catch(err => {
            console.log("API error : ", err);
          }),
          (err) => {
            console.log("err : ", err);
          }
      },
      fetchArticles () {
        this.$store.dispatch('FETCH_ARTICLES_GROUP')
          .then((res) => {
            this.articles = res.payload;
            console.log("articles: ", this.articles);
          })
          .catch(err => {
            console.log("API error : ", err);
          }),
          (err) => {
            console.log("err : ", err);
          }
      },
      fetchTrendingPlaylists () {
        this.$store.dispatch('FETCH_TRENDING_PLAYLIST_GROUP')
          .then((res) => {
            this.tendingPlaylists = res.payload;
            console.log("trending playlists: ", this.tendingPlaylists);
          })
          .catch(err => {
            console.log("API error : ", err);
          }),
          (err) => {
            console.log("err : ", err);
          }
      },
      createGroup () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            if (this.selectAllInterest) {
              this.group.selectAllInterest = 1
              this.group.csvGroupInterestsId = null
            }
            if (this.selectAllExpert) {
              this.group.selectAllExpert = 1
              this.group.csvGroupExpertsId = null
            }
            if (this.selectAllArticle) {
              this.group.selectAllArticle = 1
              this.group.csvGroupArticlesId = null
            }
            if (this.selectAllPlaylists) {
              this.group.selectAllTrendPlaylist = 1
              this.group.csvGroupTrendPlaylistId = null
            }
            if (this.selectedTags && this.selectedTags.length > 0) {
              let emailArray = this.selectedTags.map(x => {
                return x.tagKey
              })
              this.group.csvGroupVideoTags = emailArray.join(',')
            } else {
              this.group.csvGroupVideoTags = null
            }
            if (!this.group.headerColor || this.group.headerColor === '') {
              this.group.headerColor = '#f0617d'
            }
            if (!this.group.footerColor || this.group.footerColor === '') {
              this.group.footerColor = '#f0617d'
            }
            if (!this.group.buttonColor || this.group.buttonColor === '') {
              this.group.buttonColor = '#f0617d'
            }
            if (!this.group.headingColor || this.group.headingColor === '') {
              this.group.headingColor = '#f0617d'
            }
            console.log("this.group : ", this.group);
            let createGroup = () => {
              this.$store.dispatch('ADD_GROUP', this.group)
                .then((res) => {
                  console.log("ADD_GROUP res : ", res);
                  if (res) this.showPopup('Success!', 'Corporation Group is successfully created', 'success', () => this.$router.push('/admin/groups'))
                  else this.showPopup('Error!', 'Unable to process.', 'error')
                })
                .catch(err => {
                  this.showPopup('Error!', 'Group already exitst.', 'error')
                  console.log("ADD_GROUP API error : ", err);
                })
            };
            createGroup();
          }

        })
      },
      showPopup(title, msg, popupType, cb){
        this.$swal(title, msg, popupType
        ).then(res => {
          cb && cb();
          return res
        })
      },
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      }
    },
    computed:{
        routeName () {
            const {name} = this.$route;
            return this.capitalizeFirstLetter(name);
        }
    },
    created() {
      this.fetchInterests();
      this.fetchExperts();
      this.fetchArticles();
      this.fetchTrendingPlaylists();
      this.fetchTags();
    }
    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Groups/CreateGroup.vue